import { render } from "./trainer-model.vue?vue&type=template&id=1e75a1a8"
import script from "./trainer-model.vue?vue&type=script&lang=js"
export * from "./trainer-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__